import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class GetAnalysisService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getAnalysis(analysisId) {
        return this.httpClient.get(environment.api.base + 'efas?id=' + analysisId)
            .pipe(catchError((err) => {
            if (err.error instanceof Error) {
                console.error('Error:', err.error.message);
            }
            else {
                console.error(`Backend error code ${err.status} : ${err.error}`);
            }
            return new Observable();
        }));
    }
    removeAnalysis(analysisId) {
        return this.httpClient.delete(environment.api.base + 'efas/' + analysisId, {});
    }
}
GetAnalysisService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GetAnalysisService_Factory() { return new GetAnalysisService(i0.ɵɵinject(i1.HttpClient)); }, token: GetAnalysisService, providedIn: "root" });
